import {createSlice, isAnyOf} from '@reduxjs/toolkit';
import {loadDeskSuggestionsAndData} from '../../data/desks';
import {
  selectFloor,
  selectDesks,
  selectArea,
  resetWorkspaceReservation,
  inviteesSelected,
  saveGroupWorkspaceReservation,
  saveWorkspaceReservation,
  selectLocation,
} from './actions';
import {initialState} from './initialState';

const slice = createSlice({
  name: 'ui/workspaceReservation',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(selectDesks, (state, action) => {
        if (action.payload) {
          state.deskIds = action.payload;
        }
      })
      .addCase(selectLocation, (state, action) => {
        const {buildingId, floorId, areaId} = action.payload;
        // The order of setting the building/floor and area really matters.
        // Example: setting the building first, the app will, for a very brief moment be with the invalid floor and area
        // and that will make the booking screen to close right away, as the selection is valid.
        // state.suggestedDeskId = '';
        state.areaId = areaId;
        state.floorId = floorId;
        state.buildingId = buildingId;
      })
      .addCase(selectFloor, (state, action) => {
        const floorId = action.payload;
        state.deskIds = [];
        state.floorId = floorId;
      })
      .addCase(selectArea, (state, action) => {
        const areaId = action.payload;
        state.deskIds = [];
        state.areaId = areaId;
      })
      .addCase(resetWorkspaceReservation, (state) => {
        state.deskIds = [];
        state.areaId = '';
        state.floorId = '';
        state.buildingId = '';
        state.invitees = [];
        state.isSavingWorkspaceReservation = false;
      })
      .addCase(inviteesSelected, (state, action) => {
        state.invitees = action.payload;
      })
      .addCase(loadDeskSuggestionsAndData.fulfilled, (state, action) => {
        state.deskIds = action.payload;
      })
      .addMatcher(
        isAnyOf(
          saveWorkspaceReservation.fulfilled,
          saveWorkspaceReservation.rejected,
          saveGroupWorkspaceReservation.fulfilled,
          saveGroupWorkspaceReservation.rejected,
        ),
        (state) => {
          state.isSavingWorkspaceReservation = false;
        },
      )
      .addMatcher(isAnyOf(saveWorkspaceReservation.pending, saveGroupWorkspaceReservation.pending), (state) => {
        state.isSavingWorkspaceReservation = true;
      });
  },
});

export const workspaceReservationReducer = slice.reducer;
